<template>
  <span v-if="isCurrency" :class="className">{{ currentNumber | formatNumber('currency') }} <slot></slot></span>
  <span v-else :class="className">{{ currentNumber | formatAmount }} <slot></slot></span>
</template>

<script>
import NumericUtils from '../../utils/numeric';

export default {
  name: 'AppCountUp',
  props: {
    startVal: {
      type: [Number, String],
      default: 0,
      required: true,
    },
    endVal: {
      type: [Number, String],
      required: true,
    },
    duration: {
      type: Number,
      default: 1000,
    },
    isCurrency: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: 'count-up',
    },
  },
  data() {
    return {
      currentNumber: parseInt(this.startVal, 0),
    };
  },
  mounted() {
    this.countUp();
  },
  methods: {
    countUp() {
      NumericUtils.animateNumber(parseInt(this.endVal, 0), this.duration, parseInt(this.startVal, 0), (currentNumber) => {
        this.currentNumber = currentNumber;
        this.$emit('on-value-changed', this.currentNumber);
      });
    },
  },
  watch: {
    startVal() {
      this.countUp();
    },
    endVal() {
      this.countUp();
    },
  },
};
</script>

<style lang="scss" scoped>
.count-up {
  font-size: 2em;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/app-count-up/index.vue